var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{ref:"imageElement",staticClass:"image",class:{ 'clickable-image': _vm.viewer },attrs:{"src":_vm.getUrl()}})}
var staticRenderFns = []

export { render, staticRenderFns }